"use strict";
// client side models for procurement
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAssignType = exports.DropffDeclinedReasons = exports.CancelReasons = exports.PaymentTerms = exports.MarketplaceRequestStatus = exports.LPOSegment = exports.InternalRequestStatus = void 0;
var InternalRequestStatus;
(function (InternalRequestStatus) {
    InternalRequestStatus["Declined"] = "Declined";
    InternalRequestStatus["Approved"] = "Approved";
})(InternalRequestStatus = exports.InternalRequestStatus || (exports.InternalRequestStatus = {}));
var LPOSegment;
(function (LPOSegment) {
    LPOSegment["Header"] = "header";
    LPOSegment["Footer"] = "footer";
    LPOSegment["Signature"] = "signature";
    LPOSegment["Stamp"] = "stamp";
})(LPOSegment = exports.LPOSegment || (exports.LPOSegment = {}));
var MarketplaceRequestStatus;
(function (MarketplaceRequestStatus) {
    MarketplaceRequestStatus["Created"] = "awaiting_equipment";
    MarketplaceRequestStatus["ClientApproval"] = "awaiting_client_approval";
    MarketplaceRequestStatus["SupplierApproval"] = "awaiting_supplier_approval";
    MarketplaceRequestStatus["AwaitingLPO"] = "awaiting_lpo";
    MarketplaceRequestStatus["AwaitingLPOReview"] = "awaiting_lpo_review";
    MarketplaceRequestStatus["Completed"] = "completed";
})(MarketplaceRequestStatus = exports.MarketplaceRequestStatus || (exports.MarketplaceRequestStatus = {}));
exports.PaymentTerms = [
    "Cash upon Mobilization",
    "Cash in advance every 10 Days",
    "CDC Before Delivery",
    "CDC Upon Invoice Submission",
    "CDC or Cash in Advance with LPO",
    "15 days PDC in Advance",
    "30 days after Invoice",
    "30 days PDC in advance",
    "30 days PDC with security cheque",
    "30 days PDC cheque in advance + security cheque worth of 2 months rental",
    "45 Days PDC in Advance",
    "60 days open credit",
    "60 days Credit from Invoice Submission With PO",
    "Payable by Installments",
];
var CancelReasons;
(function (CancelReasons) {
    CancelReasons["SupplierTimedOut"] = "Supplier timed out";
    CancelReasons["ClientCancelledCounterOffer"] = "Client cancelled counter offer";
    CancelReasons["ClientTimedOut"] = "Client timed out";
    CancelReasons["ClientApproval"] = "Client approval failed";
    CancelReasons["AwaitingLpoTimeout"] = "Awaiting LPO timed out";
    CancelReasons["EquipmentBusy"] = "Equipment busy";
    CancelReasons["EquipmentBroken"] = "Equipment broken down";
    CancelReasons["OperatorUnavailable"] = "Operator unavailable";
    CancelReasons["ClientUnsuitable"] = "Client unsuitable";
    CancelReasons["RateUnsuitable"] = "Rate unsuitable";
    CancelReasons["LocationUnsuitable"] = "Location unsuitable";
    CancelReasons["PaymentTermsUnsuitable"] = "Payment terms unsuitable";
    CancelReasons["Other"] = "Other";
})(CancelReasons = exports.CancelReasons || (exports.CancelReasons = {}));
var DropffDeclinedReasons;
(function (DropffDeclinedReasons) {
    DropffDeclinedReasons["Price"] = "Price";
    DropffDeclinedReasons["MachineNotFound"] = "Machine not found";
    DropffDeclinedReasons["Skimming"] = "Skimming";
    DropffDeclinedReasons["InvalidDocument"] = "Invalid Document";
    DropffDeclinedReasons["OperatorNotAvailable"] = "Operator Not Available";
})(DropffDeclinedReasons = exports.DropffDeclinedReasons || (exports.DropffDeclinedReasons = {}));
var RequestAssignType;
(function (RequestAssignType) {
    RequestAssignType["OrderCancelled"] = "order_cancelled";
    RequestAssignType["OrderConfirmed"] = "order_confirmed";
    RequestAssignType["FollowUp"] = "follow_up";
})(RequestAssignType = exports.RequestAssignType || (exports.RequestAssignType = {}));
//# sourceMappingURL=marketplace_order.js.map